import React, { PureComponent } from "react";

import { AutoSizer } from "react-virtualized";

import styles from "./style.module.css";
import ChordDiagram from "components/ChordDiagram/ChordDiagram";

import { MAX_ARCS } from "containers/Home/reducer";
import { colors as nextColors } from "containers/Next/NextReducer";

import { rgb } from "d3-color";

const MAX_CHAR_LENGTH = 18;

export default class LeakageChart extends PureComponent {
  render() {
    const {
      dataset,
      rankedFields,
      width,
      height,
      showTitle,
      hoverGroup,
      hoverRibbon,
      gridType,
      hoverNode,
      isFixSvg,
      isSmall,
      isReport,
      isReportMuscle,
      isHideSearch,
      insight,
      isSense,
      isTiny,
      isHoverInsights,
      hideChords,
      searchOptions,
      isSenseTile,
      isNextReport,
      isMedium,
      isSenseSmallOld,
      isTableau,
      isGoogle,
      isGoogleSense,
      node,
      isExploreTask,
      handleMuscleClick,
      innerRadius,
      isReportExpand,
      isInfographic,
      maxArcCount,
      hideOther,
      isInfoChart
    } = this.props;

    if (dataset === undefined || dataset.fields === undefined) {
      return <div />;
    }

    const isSenseSmall = !isHoverInsights && isSenseTile;

    const data = dataset.interaction_scores_lookup ?? {};

    const bestFieldsUnfiltered = (rankedFields ?? []).map((field, i) => ({
      label: field.label,
      color: nextColors[i % nextColors.length]
    }));

    const scores = dataset.field_scores ?? {};

    const bestFields = bestFieldsUnfiltered.filter(({ label }) => scores[label] > 0 && data[label] != undefined);

    bestFields.sort((a, b) => scores[b.label] - scores[a.label]);

    const retMaxArcs = maxArcCount ?? MAX_ARCS;

    let matrix = [];

    if (bestFields.length > retMaxArcs) {
      let otherField = [];
      bestFields.forEach((fieldOne, fieldOneIndex) => {
        const currField = [];
        if (fieldOneIndex < retMaxArcs) {
          let otherVal = 0;
          bestFields.forEach((fieldTwo, fieldTwoIndex) => {
            const val = data?.[fieldOne.label]?.[fieldTwo.label] ?? 0;
            if (fieldTwoIndex < retMaxArcs) {
              currField.push(val);
            } else {
              otherVal += val;
            }
          });
          if (!hideOther) {
            currField.push(otherVal);
          }
          matrix.push(currField);
        } else {
          if (!hideOther) {
            bestFields.forEach((fieldTwo, fieldTwoIndex) => {
              const val = data?.[fieldOne.label]?.[fieldTwo.label] ?? 0;
              if (fieldTwoIndex < retMaxArcs) {
                const otherVal = otherField[fieldTwoIndex] ?? 0;
                otherField[fieldTwoIndex] = otherVal + val;
              } else {
                const otherVal = otherField[retMaxArcs] ?? 0;
                otherField[retMaxArcs] = otherVal + val;
              }
            });
          }
        }
      });
      if (!hideOther) {
        matrix.push(otherField);
      }
    } else {
      matrix = bestFields.map((fieldOne) => {
        return bestFields.map((fieldTwo) => {
          return data?.[fieldOne.label]?.[fieldTwo.label] ?? 0;
        });
      });
    }

    const hoverColor =
      hoverNode?.fields && hoverNode?.fields.length > 0 && hoverNode?.fields[0]?.color
        ? hoverNode?.fields[0]?.color
        : undefined;

    let hasChord = true;
    let isFaded = false;

    if (insight) {
      const currentVar = insight.narrative?.columnLabel;
      const isSignificant = bestFields.find((field) => field.label === currentVar);

      if (!isSignificant) {
        if (isSmall && (isReport || isExploreTask || node)) {
          hasChord = false;
        }

        isFaded = true;
      }
    }

    const isLoading = dataset.dataset_status != "DONE" && dataset.dataset_status != "ERROR";

    const searchField = searchOptions?.[0]?.field || searchOptions?.[0]?.filterField;

    const rawComputedHoverGroup =
      searchField !== undefined && rankedFields.find((f) => f.label === searchField)
        ? rankedFields.find((f) => f.label === searchField).rank
        : isLoading && isSmall
          ? -1
          : hoverGroup === -1 || hoverRibbon !== undefined
            ? undefined
            : hoverGroup;

    // const computedHoverGroup = rawComputedHoverGroup !== undefined && rawComputedHoverGroup < retMaxArcs ? rawComputedHoverGroup : undefined;
    const computedHoverGroup = rawComputedHoverGroup;

    if (!matrix) {
      return <div />;
    }

    const ribbonOpacity = isNextReport
      ? isSenseSmall || hideChords
        ? 0
        : 0.67
      : isSenseSmall || hideChords
        ? 0
        : 0.67;

    const rawGroupLabels =
      isSenseSmall || isSmall || isSenseSmallOld || isTiny ? undefined : bestFields.map((f) => f.label);

    const truncatedGroupLabels = rawGroupLabels?.slice(0, retMaxArcs);

    if (rawGroupLabels?.length > retMaxArcs) {
      const otherCount = rawGroupLabels.length - retMaxArcs;
      truncatedGroupLabels.push(otherCount + " Other Factors");
    }

    const groupLabels = truncatedGroupLabels?.map((label) =>
      label && label.length > MAX_CHAR_LENGTH ? label.substr(0, MAX_CHAR_LENGTH) + "..." : label
    );

    const groupLabelsFull = truncatedGroupLabels;

    const groupColors = bestFields.map((f, i) => {
      const fColor = i < retMaxArcs ? f.color : "rgb(153,153,153)";

      return hoverGroup === undefined || i === hoverGroup
        ? isFaded === true
          ? rgb(fColor).copy({ opacity: 0.1 })
          : fColor
        : rgb(fColor).copy({
            opacity: isFaded === true ? 0.2 : hideChords ? 0.15 : 0.9
          });
    }); // "#E3E4E9"

    const retHoverNode = searchField !== undefined ? undefined : hoverNode;

    const isLessImportant =
      isSmall &&
      (isReport || isExploreTask || node) &&
      (computedHoverGroup >= retMaxArcs ||
        (retHoverNode && Object.values(retHoverNode?.fields)?.find((f) => f?.rank >= retMaxArcs)));

    return (
      <div
        className={
          isInfoChart
            ? styles.leakageInfoChart
            : isInfographic
              ? styles.leakgeChartInfographic
              : isExploreTask
                ? styles.leakageChartTask
                : isNextReport
                  ? styles.leakageChartRep
                  : isSenseSmallOld
                    ? styles.leakageChartSenseOld
                    : isMedium
                      ? styles.leakageChartSenseMed
                      : isHoverInsights
                        ? styles.leakageChartSenseLarge
                        : isSenseSmall
                          ? styles.leakageChartSenseSmall
                          : isSense
                            ? styles.leakageChartSense
                            : isReport
                              ? styles.leakageChartReport
                              : styles.leakageChart
        }
        id={isNextReport ? "leakageSizer" : isFixSvg ? "leakageChart" : "oLeakageChart"}
      >
        {hasChord === false ? (
          <div className={styles.notImportant}>{"NOT AN IMPORTANT FACTOR GIVEN OTHER VARIABLES"}</div>
        ) : isLessImportant ? (
          <div className={styles.notImportant}>{"A LESS IMPORTANT FACTOR GIVEN OTHER VARIABLES"}</div>
        ) : (
          <React.Fragment />
        )}
        {showTitle && (
          <div className={styles.boldItem} style={{ width: "100%", textAlign: "center" }}>
            {"Correlation with Other Fields"}
          </div>
        )}
        {isLoading && (
          <div className={styles.notImportant}>
            <div />
          </div>
        )}
        {isNextReport ? (
          <AutoSizer>
            {({ width, height }) => (
              <div
                style={{
                  marginLeft: width / 4 + "px",
                  marginTop: isReportExpand ? "40px" : "0px"
                }}
              >
                <ChordDiagram
                  matrix={matrix}
                  width={width * 0.5}
                  height={isReportExpand ? height * 0.8 : height}
                  componentId={1}
                  innerRadius={
                    isReportExpand ? 210 : width * 0.2 > 0 ? (width < 700 ? width * 0.195 : width * 0.205) : 50
                  }
                  groupColors={groupColors}
                  groupLabelsFull={groupLabelsFull}
                  groupLabels={groupLabels ?? []}
                  hoverGroup={computedHoverGroup}
                  hoverColor={hoverColor}
                  hoverNode={retHoverNode}
                  hoverRibbon={searchField !== undefined ? undefined : hoverRibbon === -1 ? undefined : hoverRibbon}
                  disableHover={isNextReport && searchField !== undefined}
                  isReport={isReport}
                  ribbonOpacity={ribbonOpacity.toString()}
                  groupOnClick={(e) => {
                    if (!isNextReport) {
                      return;
                    }
                    if (computedHoverGroup === e) {
                      return handleMuscleClick();
                    } else {
                      if (e >= retMaxArcs) {
                        return;
                      }
                      return handleMuscleClick(bestFields?.[e]?.label);
                    }
                  }}
                  strokeWidth={isSenseSmall || hideChords ? 0 : 1}
                />
              </div>
            )}
          </AutoSizer>
        ) : (
          <ChordDiagram
            matrix={matrix}
            width={
              isTableau
                ? 300
                : isGoogle
                  ? 200
                  : isSenseSmallOld
                    ? 175
                    : isHoverInsights
                      ? isGoogleSense
                        ? 200
                        : 300
                      : isSenseSmall
                        ? 175
                        : isSense
                          ? 300
                          : width
            }
            height={
              isTableau
                ? 400
                : isGoogle
                  ? 300
                  : isSenseSmallOld
                    ? 175
                    : isHoverInsights
                      ? isGoogleSense
                        ? 200
                        : 300
                      : isSenseSmall
                        ? 175
                        : isSense
                          ? 400
                          : height
            }
            componentId={1}
            innerRadius={
              innerRadius !== undefined
                ? innerRadius
                : isTiny
                  ? 18
                  : isExploreTask
                    ? 153
                    : isTableau
                      ? 115
                      : isGoogle
                        ? 65
                        : isSenseSmallOld
                          ? 40
                          : isHoverInsights
                            ? isGoogleSense
                              ? 68
                              : 100
                            : isSenseSmall
                              ? 40
                              : isSense
                                ? 100
                                : isSmall
                                  ? height * 0.29
                                  : height * 0.405
            }
            groupColors={groupColors}
            groupLabelsFull={groupLabelsFull}
            groupLabels={groupLabels ?? []}
            hoverGroup={computedHoverGroup}
            hoverColor={hoverColor}
            hoverNode={retHoverNode}
            hoverRibbon={searchField !== undefined ? undefined : hoverRibbon === -1 ? undefined : hoverRibbon}
            isReport={isReport}
            ribbonOpacity={ribbonOpacity.toString()}
            strokeWidth={isSenseSmall || hideChords ? 0 : 1}
          />
        )}
      </div>
    );
  }
}
